import React from "react";

//import classes from './Button.css';
import "./Button.css";

const button = (props) => {
  let buttonClass = "Button " + props.btnType;

  return (
    <div>
      <button
        disabled={props.disabled}
        // className={[classes.Button, classes[props.btnType]].join(' ')}
        className={buttonClass}
        onClick={props.clicked}
      >
        {props.children}
      </button>
    </div>
  );
};

export default button;
